<template>
  <div class="incompleted-tab">
    <div
      class="tab"
      :class="tab === 'incompleted' ? 'on' : ''"
      @click="tabChange('incompleted')"
    >
      <img
        v-if="tab === 'incompleted'"
        src="/static/img/ico-incompleted-pay-blue.png"
        alt
      />
      <img v-else src="/static/img/ico-incompleted-pay-grey.png" alt />
      불완전 결제 처리 리스트
      {{ incompletedCount }}
    </div>

    <div
      class="tab"
      :class="tab === 'pending' ? 'on' : ''"
      @click="tabChange('pending')"
    >
      <img
        v-if="tab === 'pending'"
        src="/static/img/ico-pending-blue.png"
        alt
      />
      <img v-else src="/static/img/ico-pending-grey.png" alt />
      보류처리 리스트
      {{ pendingCount }}
    </div>
  </div>
</template>


<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */

import Configuration from '@/js/Configuration';

export default {
  props: ['tab', 'uID',
    'refreshEvent',
  ],
  data: () => ({
    prevIncompletedCount: 0,
    incompletedCount: 0,
    pendingCount: 0,
    loading: true,
    audio: null,
  }),
  created() {
    //
    this.audio = new Audio('/static/audio/classic-alarm.wav');
    if (this.audio) {
      this.audio.autoplay = false;
      this.audio.id = 'myAudio';
    }

    //
    this.getIncompletedCount(false);
    this.getPendingCount(false);
    this.interval = setInterval(() => {
      if (!this.loading) {
        this.getIncompletedCount(true);
        this.getPendingCount(true);
      }
    }, 5000);
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    //
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
  },
  watch: {
    refreshEvent() {
      if (!this.loading) {
        this.getIncompletedCount(false);
        this.getPendingCount(false);
      }
    },
  },
  methods: {
    async getIncompletedCount(polling) {
      this.loading = true;
      if (!polling) {
        this.incompletedCount = 0;
      }

      try {
        const res = await this.$http.get(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/count?state=2&state=3&approveResult=3&polling=${polling}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.incompletedCount = res.data.count;
        this.loading = false;
        this.playAlarm();
      } catch (e) {
        this.loading = false;
        if (!polling) {
          this.incompletedCount = 0;
          alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        }

        console.error(e);
      }
    },
    async getPendingCount(polling) {
      this.loading = true;
      if (!polling) {
        this.pendingCount = 0;
      }

      try {
        const res = await this.$http.get(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/count?state=8&state=11&approveResult=3&polling=${polling}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.pendingCount = res.data.count;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        if (!polling) {
          this.pendingCount = 0;
          alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        }

        console.error(e);
      }
    },
    tabChange(tab) {
      this.$emit('tabChange', tab);
    },
    async playAlarm() {
      if (this.incompletedCount > 0 && this.prevIncompletedCount !== this.incompletedCount && this.audio) {
        this.prevIncompletedCount = this.incompletedCount;

        try {
          await this.audio.play();
          this.$emit('errorPlayAarm', false);
        } catch (e) {
          console.error('play error:', e);
          this.$emit('errorPlayAarm', true);
        }
      }
    },
  },
};
</script>

<style>
.incompleted-tab {
  display: flex;
  width: 100%;
  height: 80px;
}
.incompleted-tab .tab {
  display: flex;
  width: 50%;
  height: 100%;
  font-size: 12.8px;
  font-weight: bold;
  line-height: 24px;
  color: #868686;
  justify-content: center;
  align-items: center;
  border-bottom: 4px solid #ebf2fe;
  cursor: pointer;
}
.incompleted-tab .tab img {
  margin-right: 4px;
  width: 24px;
  height: 24px;
}
.incompleted-tab .tab.on {
  color: #2470f1;
  background-color: #ebf2fe;
  border-bottom: 4px solid #0058ee;
}
</style>



// WEBPACK FOOTER //
// src/components/incompletedPay/IncompletedTab.vue